import { currencyFormatter } from 'xangle-charts'

import { EcosystemGeneralInfo, FlagAdapterCountInfo, type FlagAdapterCountPercentageInfo } from '~/api/repository'
import { setComma, setFixed } from '~/utils/number'

export class EcosystemGeneralModel {
  private readonly _flagTotalProjectCountInfo?: FlagAdapterCountInfo
  private readonly _flagTvlInfo?: FlagAdapterCountPercentageInfo
  private readonly _flagSticknessInfo?: FlagAdapterCountPercentageInfo
  private readonly _flagTransactionCountInfo?: FlagAdapterCountPercentageInfo

  constructor (res: EcosystemGeneralInfo) {
    this._flagTotalProjectCountInfo = res.flagTotalProjectCountInfo
    this._flagTvlInfo = res.flagTvlInfo
    this._flagSticknessInfo = res.flagSticknessInfo
    this._flagTransactionCountInfo = res.flagTransactionFeeInfo
  }

  get totalProjectCount () {
    return this._flagTotalProjectCountInfo?.OBJ.CNT ?? '0'
  }

  get tvl () {
    return currencyFormatter({
      number: this._flagTvlInfo?.OBJ.CNT ?? 0,
      unit: '',
      decimalPoint: 2,
      contraction: true,
    })
  }
  get tvlPercentage () {
    return setComma(setFixed(this._flagTvlInfo?.OBJ.PRTG ?? '0', 2))
  }

  get stickness () {
    return setComma(setFixed(this._flagSticknessInfo?.OBJ.CNT ?? '0', 2))
  }

  get transactionCount () {
    return setComma(this._flagTransactionCountInfo?.OBJ.CNT ?? '0')
  }

  get transactionCountPercentage () {
    return setComma(setFixed(this._flagTransactionCountInfo?.OBJ.PRTG ?? '0', 2))
  }
}